import type { SchoolType } from '@kimuno/api-sdk/lib/types/responses/Text';
import immutable from 'object-path-immutable';

import { AsyncActionStatus } from '../actions/common.actionTypes';
import {
	FETCH_SCHOOL_TYPES,
	type FetchSchoolTypesAction,
} from '../actions/schoolTypes.actionsTypes';
import type { StoreItem } from '.';

type SchoolTypeActionTypes = FetchSchoolTypesAction;

export type SchoolTypeState = StoreItem<SchoolType[]>;

const initialState: SchoolTypeState = {
	data: [],
	status: AsyncActionStatus.INITIAL,
};

// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature / existing call sites)
const schoolTypes = (state = initialState, action: SchoolTypeActionTypes) => {
	switch (action.type) {
		case FETCH_SCHOOL_TYPES.START:
			return immutable(state).set('status', AsyncActionStatus.LOADING).value();

		case FETCH_SCHOOL_TYPES.SUCCESS:
			return immutable(state)
				.set('data', action.result)
				.set('status', AsyncActionStatus.READY)
				.value();

		case FETCH_SCHOOL_TYPES.ERROR:
			return immutable(state)
				.set('error', action.error.message)
				.set('status', AsyncActionStatus.ERROR)
				.value();

		default:
			return state;
	}
};

export default schoolTypes;
